import { Mail, Phone, MapPin } from "lucide-react";
import { useEffect } from "react";
import { IMG } from "@/lib/images";
import { PageHeader } from "@/components/PageHeader";
import { Reveal } from "@/components/Reveal";
import { SEO } from "@/components/SEO";
import { pageSEO } from "@/lib/seo";
import { ConsultationForm } from "@/components/ConsultationForm";
import { BookConsultation } from "@/components/BookConsultation";
import { useLang } from "@/i18n/LanguageContext";
import { useSiteConfig } from "@/context/SiteConfigContext";

const CALL_LABEL = { fr: "Appeler", it: "Chiama", en: "Call" };

export default function Contact() {
  const { c, lang } = useLang();
  const { config } = useSiteConfig();
  const p = c.pages.contact;
  const email = config.email || "marie@olimedesign.fr";
  const phone = config.phone || "";
  const telHref = phone.replace(/[^+\d]/g, "");
  useEffect(() => {
    if (typeof window !== "undefined" && window.location.hash === "#form") {
      const t = setTimeout(() => document.getElementById("form")?.scrollIntoView({ behavior: "smooth", block: "start" }), 400);
      return () => clearTimeout(t);
    }
  }, []);
  return (
    <div data-testid="contact-page">
      <SEO {...pageSEO("contact", lang)} path="/contact" lang={lang} image={IMG.contact} />
      <PageHeader eyebrow={p.eyebrow} lines={p.hLines} title="Contact" subtitle={p.subtitle} image={IMG.contact} />
      <section className="py-24 lg:py-32 bg-olime-bg">
        <div className="container-olime max-w-4xl space-y-14 lg:space-y-16">
          <div>
            <Reveal>
              <span className="eyebrow">{p.coord}</span>
              <div className="mt-8 space-y-8">
                <div className="flex items-start gap-4"><Mail size={18} className="text-olime-stone mt-1" /><div><p className="text-xs uppercase tracking-[0.15em] text-olime-muted">{p.emailLabel}</p><a href={`mailto:${email}`} data-testid="contact-email" className="text-olime-ink mt-1 inline-block link-underline">{email}</a></div></div>
                {phone && (
                  <div className="flex items-start gap-4"><Phone size={18} className="text-olime-stone mt-1" /><div><p className="text-xs uppercase tracking-[0.15em] text-olime-muted">{p.phoneLabel}</p><a href={`tel:${telHref}`} data-testid="contact-phone" className="text-olime-ink mt-1 inline-block link-underline">{phone}</a></div></div>
                )}
                <div className="flex items-start gap-4"><MapPin size={18} className="text-olime-stone mt-1" /><div><p className="text-xs uppercase tracking-[0.15em] text-olime-muted">{p.zoneLabel}</p><p className="text-olime-ink mt-1">{p.zoneValue}</p></div></div>
              </div>
              {phone && (
                <a href={`tel:${telHref}`} data-testid="contact-call-btn" className="btn-ink mt-8 inline-flex"><Phone size={14} /> {CALL_LABEL[lang] || CALL_LABEL.fr}</a>
              )}
              <p data-testid="contact-intro" className="mt-10 text-olime-muted leading-relaxed max-w-sm">{p.formIntro}</p>
              <p className="mt-10 font-serif text-2xl italic text-olime-stone leading-snug whitespace-pre-line">{p.tagline}</p>
            </Reveal>
          </div>
          <div id="form">
            <Reveal delay={0.1}>
              <div className="bg-white border border-olime-line p-8 lg:p-12">
                <h2 className="font-serif text-3xl md:text-4xl mb-8">{p.formTitle}</h2>
                <ConsultationForm />
                <div className="mt-8 pt-8 border-t border-olime-line"><BookConsultation variant="ink" testId="contact-book-cta" /></div>
              </div>
            </Reveal>
          </div>
        </div>
      </section>
    </div>
  );
}
